@if (!hideHeader) {
  <div mat-dialog-title>
    <span>{{ title }}</span>
    @if (!hideCloseIcon) {
      <mat-icon mat-dialog-close class="close">close</mat-icon>
    }
  </div>
}
<div mat-dialog-content>
  <ng-content></ng-content>
</div>
@if (!hideFooter) {
  <div mat-dialog-actions class="dialog-base-actions">
    @if (cancelButton) {
      <button mat-flat-button mat-dialog-close class="cancel-button" color="accent">
        {{ 'GENERIC.CANCEL' | translate }}
      </button>
    }
    <button
      mat-flat-button
      [disabled]="disabled"
      class="action-button"
      [ngClass]="{ 'second-button': cancelButton }"
      (click)="buttonClicked()"
      color="primary"
    >
      {{ button }}
    </button>
  </div>
}
